<mat-card appearance="outlined" class="ai-card">
  <app-card-header [displayName]="title()">
    @if (isDone()) {
      <span class="notification-badge mat-font-label-sm notification-badge--success">
        <mat-icon>check_circle</mat-icon>Done
      </span>
    } @else {
      <span class="notification-badge mat-font-label-sm notification-badge--running">
        <mat-icon class="spin-icon">autorenew</mat-icon>Running
      </span>
    }
  </app-card-header>
  <mat-card-content class="px-3 pt-2 pb-3">
    @if (!isDone() && toolCall(); as toolCall) {
      <div class="todo-list-card__activity-row d-flex align-items-center gap-2 mb-2 px-2 py-1">
        <span class="todo-list-card__spinner"></span>
        <span class="mat-font-label-sm mat-text-on-surface-variant fw-semibold">{{ toolCall.label }}</span>
      </div>
    }
    <app-todo-list [todos]="todos()" title="" />
  </mat-card-content>
</mat-card>
